/**
 * The Episodes page's address — a contract other pages link by (Overview, Uploads, a
 * collection, a pod): `/production/episodes?pod=&operator=&task=&collection=&from=&to=&result=`.
 * The route's `validateSearch` runs in the console's first-load bundle, so what it reads
 * lives here, importing nothing.
 */

/** How an episode ended, as the floor counts it: checks first, then the collector. */
export type Result = "successful" | "pending" | "unsuccessful" | "failedChecks";

/** The same outcomes as the address spells them. "Waiting for review" is `no-outcome`. */
export const RESULT_PARAMS = ["successful", "unsuccessful", "failed-checks", "no-outcome"] as const;
export type ResultParam = (typeof RESULT_PARAMS)[number];

const PARAM_RESULT: Record<ResultParam, Result> = {
  successful: "successful",
  unsuccessful: "unsuccessful",
  "failed-checks": "failedChecks",
  "no-outcome": "pending",
};

export const resultOf = (param: ResultParam): Result => PARAM_RESULT[param];

export interface EpisodesSearch {
  /** The first and last calendar day shown, on the console's clock. */
  readonly from?: string;
  readonly to?: string;
  readonly pod?: string;
  readonly operator?: string;
  /** A task assignment. */
  readonly task?: string;
  readonly collection?: string;
  readonly result?: ResultParam;
}

/** The address's filters this page could not read — an unknown result, a day that is not
 *  a day — so it can say it ignored them rather than quietly show everything. */
export function ignoredFilters(raw: URLSearchParams, search: EpisodesSearch): readonly string[] {
  return (["from", "to", "result"] as const).filter((name) => {
    const given = raw.get(name);
    return given !== null && given.trim() !== "" && search[name] === undefined;
  });
}
